import {BaseApi} from "@/api/base-api";
import Vue from 'vue';

export class GuestApi extends BaseApi {
    static apiUri = 'guests';

    /** @return {Promise<EntityHttpResponse<PageResponse<GuestDto>>>} */
    static getAllGuests() {
        return Vue.http.get(this.apiUri)
    }

    /** @return {Promise<EntityHttpResponse<GuestWithBankDto>>} */
    static getById (id) {
        return super.getById(id);
    }

    /**
     * @return {Promise<EntityHttpResponse<PageResponse<BookingBasicDto>>>}
     * @param {Number} id
     * */
    static getBookingsByGuestId (id) {
        return Vue.http.get(this.apiUri + '/' + id + '/bookings')
    }
}
